import Money from "@/components/Money";
import { Sparkles } from "lucide-react";
import { addOnPalette } from "@/components/car/addOnPalette";

/**
 * Additional services list on the car-detail page (Iter 67p).
 *
 * Same visual language as the insurance plans / booking rules sections —
 * each add-on card is tinted with a keyword-routed palette and shows a
 * coloured icon medallion. Falls back to a neutral indigo palette when the
 * vendor-supplied add-on name doesn't match anything in the matcher.
 */
export default function CarAddOnsList({ addOns = [] }) {
  if (!addOns || addOns.length === 0) return null;
  return (
    <div className="py-8 border-b border-border" data-testid="car-add-ons-section">
      <h3 className="font-display text-xl font-medium mb-1 flex items-center gap-2">
        <span className="h-8 w-8 rounded-lg bg-sky-50 ring-1 ring-sky-100 flex items-center justify-center">
          <Sparkles className="h-4 w-4 text-sky-600" />
        </span>
        Additional services
      </h3>
      <p className="text-sm text-neutral-500 mb-5">Optional extras you can attach at checkout.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {addOns.map((a) => {
          const pal = addOnPalette(a);
          return (
            <div
              key={a.id}
              className={`rounded-2xl border p-4 flex items-start gap-3 ${pal.ring} ${pal.bg}/40`}
              data-testid={`car-add-on-${a.id}`}
            >
              <div className={`h-10 w-10 shrink-0 rounded-xl ${pal.medallion} ring-1 ${pal.ring} flex items-center justify-center`}>
                <pal.icon className={`h-5 w-5 ${pal.medallionFg}`} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline justify-between gap-3 mb-0.5">
                  <div className="font-semibold text-neutral-900 truncate">{a.name}</div>
                  <div className="text-sm font-semibold text-right shrink-0">
                    <Money amount={a.price} />
                    <span className="text-neutral-500 font-normal">
                      {a.pricing === "one_time" ? " one-time" : "/day"}
                    </span>
                  </div>
                </div>
                {a.description && <div className="text-sm text-neutral-600 leading-snug">{a.description}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
